import { useEffect } from "react";

export function SEO({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} · people, redefined.`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
}
